import React from "react";
import Button from "react-bootstrap/Button";

const EncounterButton = ({ size, contactID, ...rest }) => {
  const openEncounter = () => {
    const url =
      process.env.REACT_APP_CAREPLAN +
      "/dist/EncounterPortal/index.html?contactid=" +
      contactID;
    window.open(url);
  };

  return (
    <Button {...rest} size={size || "sm"} onClick={() => openEncounter()}>
      Encounter
    </Button>
  );
};

export default EncounterButton;
